<template>
    <div class="warp">
      <!-- 面包屑 -->
      <!-- <breadcrumb :back="false" :crubList="[{ name: '系统配置' }, { name: '运营成果配置' }]" :title="'运营成果配置'" /> -->
      <!-- 表格 -->
      <el-table
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
                fit
                :height="bHeight"
                :header-cell-style="headerStyle"
                v-loading="loading"
                element-loading-text="请求中......"
      >
        <el-table-column
          prop="id"
          show-overflow-tooltip
          
          label="排序"
          width="80px"
        >
        </el-table-column>
        <el-table-column
          prop="title"
          show-overflow-tooltip
          
          label="内容名称"
        >
        </el-table-column>
        <el-table-column
          prop="sysNum"
          show-overflow-tooltip
          
          label="系统数据"
        >
        </el-table-column>
        <el-table-column
          prop="baseNum"
          show-overflow-tooltip
          
          label="基数"
        >
        </el-table-column>
        <el-table-column
          prop="totalNum"
          show-overflow-tooltip
          
          label="数据总和"
        >
        </el-table-column>
        <el-table-column
          prop="status"
          show-overflow-tooltip
          
          label="状态"
        >
          <template slot-scope="scope">
            <el-switch
              disabled
              v-model="scope.row.status"
              active-color="#13ce66"
              inactive-color="#ff4949"
            >
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column
          v-if="
            authorities.indexOf('sys:permission:background:hotOperational:edit') !=
            -1
          "
          label="操作"
          
          width="300px"
        >
          <template slot-scope="scope">
            <el-button
              size="small" type="primary" class="super" plain
              @click="editoer(scope.row)"
              v-if="
                authorities.indexOf(
                  'sys:permission:background:hotOperational:edit'
                ) != -1
              "
              >编辑
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 添加热点 -->
      <el-dialog
        title="编辑选项"
        :visible.sync="dialogAdd"
        :before-close="cancel"
        :close-on-click-modal="false"
        width="400"
      >
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="内容名称" prop="name">
            <el-input v-model="ruleForm.title" maxlength="64"></el-input>
          </el-form-item>
          <el-form-item label="基数" prop="baseNum">
            <el-input v-model="ruleForm.baseNum" maxlength="12"></el-input>
          </el-form-item>
          <!-- <el-form-item label="系统数据" prop="sysNum">
            <el-input v-model="ruleForm.sysNum"></el-input>
          </el-form-item> -->
          <!-- <el-form-item label="数据总和" prop="totalNum">
            <el-input v-model="ruleForm.totalNum"></el-input>
          </el-form-item> -->
          <el-form-item label="状态" prop="status" class="formitem">
            <el-switch
              v-model="ruleForm.status"
              active-color="#13ce66"
              inactive-color="#ff4949"
            >
            </el-switch>
          </el-form-item>
          <el-form-item>
            <el-button @click="resetForm('ruleForm')">取消</el-button>
            <el-button type="primary" @click="submitForm('ruleForm')"
              >确认</el-button
            >
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>
</template>

<script>
// import breadcrumb from "../../components/breadcrumb";
export default {
  components: {
    // breadcrumb,
  },
  data() {
    return {
      loading:false,
      bHeight: void 0,
      authorities: JSON.parse(window.localStorage.getItem("authorities")),
      sendInfo: {
        currentPage: 1, //页码
        pageSize: 10, //条数
      }, //检索提交数据
      tableData: [], //表格数据
      totalPage: null, //总页码
      dialogAdd: false,
      classifyList: [], //分类
      ruleForm: {
        id: null,
        title: null,
      },
      edit: false, //是否编辑
      newsDataSelect: [],
      rules: {
        baseNum: [{ required: true, message: "请输入基数", trigger: "blur" }],
        sysNum: [
          { required: true, message: "请输入系统数据", trigger: "blur" },
        ],
        title: [{ required: true, message: "请输入内容", trigger: "blur" }],
        totalNum: [
          { required: true, message: "请输入数据总和", trigger: "blur" },
        ],
      },
    };
  },
  computed: {
    errors() {
      return this.$vuerify.$errors; // 错误信息会在 $vuerify.$errors 内体现
    },
  },
  methods: {
    doLayout() {
            this.$nextTick(() => {
              if (this.$refs.multipleTable && this.$refs.multipleTable.doLayout) {
                this.$refs.multipleTable.doLayout()
              }
            })
          },
          // 表头样式回调
          headerStyle() {
            return 'backgroundColor:#F7F7F7;fontSize:14px;color:#595959;fontWeight:500;padding:0;line-height:40px'
          },
    chooseItem(data) {
      console.log(data);
      this.ruleForm = Object.assign(this.ruleForm, data);
    },
    // 添加按钮
    addbtn() {
      this.edit = false;
      this.getSelect();
    },
    submitForm(formName) {
      console.log(this.ruleForm);
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.edit) {
            this.$axioscBody
              .post("/backstage/hotOperational/edit", this.ruleForm)
              .then((r) => {
                if (r.code == 200) {
                  this.$message({
                    type: "success",
                    message: r.msg,
                  });
                  this.getData();
                  this.resetForm(formName);
                } else {
                  this.$alert(r.msg);
                }
              });
          } else {
            this.$axioscBody
              .put("/backstage/hotOperational/edit", this.ruleForm)
              .then((r) => {
                if (r.code == 200) {
                  this.$message({
                    type: "success",
                    message: r.msg,
                  });
                  this.getData();

                  this.resetForm(formName);
                } else {
                  this.$alert(r.msg);
                }
              });
          }
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.ruleForm = {
        id: null,
        title: null,
        status: false,
        baseNum: null,
      };
      this.dialogAdd = false;
      this.$refs[formName].resetField();
    },
    // 编辑回显
    editoer(row) {
      // this.ruleForm = row;
      // this.ruleForm = {
      //   id: row.id,
      //   title: row.title,
      //   status: row.status,
      //   baseNum: row.baseNum,
      // };
      // this.edit = true;
      // this.dialogAdd = true;
      this.$router.push({path: `/systemLayout/OperationalResults/edit/${row.id}`, query: {index: '/systemLayout/OperationalResults'},param:{id:row.id}})
    },
    deleteDell(id) {
      this.$confirm("确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axiosc
            .delete("/backstage/hotProduct/del", { params: { id: id } })
            .then((r) => {
              if (r.code == 200) {
                this.$message({
                  type: "success",
                  message: "删除成功!",
                });
                this.getData();
              } else {
                this.$alert(r.msg);
              }
            });
        })
        .catch(() => {});
    },
    //切换每页显示条数
    handleSizeChange(val) {
      this.sendInfo.pageSize = val;
      this.getData();
    },
    //切换页码
    handleCurrentChange(val) {
      this.sendInfo.currentPage = val;
      this.getData();
    },
    //取消按钮
    cancel: function (type) {
      this.dialogAdd = false;
    },
    getSelect() {
      this.$axiosc.get("backstage/hotProduct/select", {}).then((r) => {
        if (r.code == 200) {
          this.newsDataSelect = r.data;
        } else {
          this.$alert(r.msg);
        }
      });
      this.dialogAdd = true;
    },
    //获取数据
    getData() {
      this.loading = true
      this.$axiosc.get("/backstage/hotOperational/list", {}).then((r) => {
        this.loading = false
        if (r.code == 200) {
          this.tableData = r.data;
        } else {
          this.$alert(r.msg);
        }
      }).catch(e=>{
        this.loading = false
      })
    },
  },
  mounted() {
    const that = this
    that.getData();
    let bh = 44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 20
          that.bHeight = document.body.clientHeight - 60  - bh 
          that.doLayout()
          window.onresize = () => {
            return (() => {
              that.$nextTick(() => {
                  bh =  44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 20
                  that.bHeight = document.body.clientHeight - 60  - bh 
                  that.doLayout()
              })
            })()
          }
  },
};
</script>
<style scoped="scoped" lang="scss">
.forms {
  /deep/ .el-select {
    width: 300px;
  }
  .child {
    .remark {
      /deep/ .el-textarea__inner {
        min-height: 122px !important;
      }
    }
    .name {
      width: 123px;
    }
  }
}

.tabs {
  border: 0;
}

.addbtns {
  margin: 10px 0;
}

/deep/ .el-dialog {
  width: 450px;
}
</style>
